<template>
  <sf-checkbox v-model="model" :rules="[rules.simpleRequiredRule]">
    <template #label>
      <span @click.stop v-html="safeCustomTerms" />
    </template>
  </sf-checkbox>
</template>

<script setup lang="ts">
import SfCheckbox from '@/components/input/SfCheckbox.vue'
import rules from '@/rules'
import DOMPurify from 'dompurify'
import { computed } from 'vue'

const props = defineProps({
  customTerms: { type: String, required: true }
})

const safeCustomTerms = computed(() => DOMPurify.sanitize(props.customTerms))

const model = defineModel<boolean>()
</script>
